
import errorParseNetwork from "~/helpers/errorParseNetwork";
import {translateEnglishRussia} from "~/helpers/translate-english-russia";

export default {
  name: "PopUpCitySelect",

  data: function () {
    return {
      search: "",

      isLoad: true
    }
  },

  computed: {
    isOpen: function () {
      return this.$store.state["city-select"]?.isOpen || false
    },

    citiesList: function () {
      return this.$store.state["city-select"]?.citiesList || {}
    },

    popularCities: function () {
      return this.citiesList?.favorites || []
    },
    searchCityList: function () {
      const seach = translateEnglishRussia((this.search || "").toLowerCase());
      const cities = (this.citiesList?.cities || []).filter((city) => {
        const name = (city?.name || "").toLowerCase();
        return Boolean(name.indexOf(seach) === 0);
      });
      return cities
    }
  },

  watch: {
    isOpen: async function () {
      if (!this.isOpen) {
        return
      }

      this.inputFocus();
      await this.getCitiesList();
    }
  },

  mounted: async function () {
    await this.getCitiesList();
  },

  methods: {
    close: function () {
      this.$store.commit("city-select/setOpen", false);
    },

    getCitiesList: async function () {
      if (Object.keys(this.citiesList).length > 0) {
        this.isLoad = false;

        return
      }

      const response = await this.$api.agent.transport.get('cities').then((res) => {
        return res.data
      }).catch(() => {
        return {}
      });
      this.$store.commit("city-select/setCitiesList", response);
      this.isLoad = false;
    },
    setCurrenctCity: async function (city) {
      this.$store.commit("loading/setLoading", {name: "popUpLoading", value: true});

      const cookiesOpt = this.$getCookiesOpt({
        path: '/',
        maxAge: 60 * 60 * 24 * 60 * 365
      })
      this.$cookies.set('accept_city', city.id, cookiesOpt);

      const body = {
        city_id: city.id
      };
      const response = await this.$api.agent.transport.put('cities/current', body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: errorParseNetwork(err.response)}
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", {name: "popUpLoading", value: false});
        this.$toast.error(response.error);

        return
      }

      const activeCitySubDomain = city?.sub_domain || "";
      const currentFullPath = this.$route?.path || "";
      const locationHost = window.location?.host || "";
      const isSubdomain = Boolean(locationHost.split(".").length >= 3);
      const host = Boolean(isSubdomain) ? locationHost.split(".")?.slice(-(locationHost.split(".").length - 1)).join('.') : locationHost;

      const currentUrl = new URL(window.location.href);
      let currentSearch = new URLSearchParams(currentUrl.search);
      currentSearch.delete('c');
      currentSearch = currentSearch.toString();

      const search = Boolean(currentSearch) ? `?${currentSearch}&c=${city.id}` : `?c=${city.id}`;
      const reloadUrl = `${window?.location?.protocol || "https:"}//${Boolean(activeCitySubDomain) ? `${activeCitySubDomain}.` : ""}${host}${currentFullPath}${search}`
      location.href = reloadUrl;
    },

    inputFocus: function () {
      if (!this.$refs.refInputSearch) {
        setTimeout(() => {
          this.inputFocus();
        }, 100);
        return
      }
      this.$refs.refInputSearch.focus();
    },
  }
}
